import { Center, Stack, Text, Title } from '@buildex/ui';
import { useTranslation } from 'react-i18next';

/**
 * Сюда же попадает прямой переход по URL неактивного модуля:
 * его роуты вообще не регистрируются (реальная защита данных — на бэке, §5).
 */
export function NotFoundPage() {
  const { t } = useTranslation();
  return (
    <Center mih="60vh">
      <Stack align="center" gap="xs">
        <Title order={2}>{t('notFound.title')}</Title>
        <Text c="dimmed">{t('notFound.text')}</Text>
      </Stack>
    </Center>
  );
}
